export default __webpack_public_path__ + "static/mockupsProPage-73869ca01827b4a5b2ee79d2303b5952.jpg";